import { wqkgx } from '../config/keys';
import { THasRegInStorage, TInfo, TInfoltd, TSetLocalStorage } from '../types';
import { decryptJson } from './decryptJson';
import { encryptEntrepreneurData } from './encryptJson';
import CryptoJS from 'crypto-js';

const getUrlParam = () => {
  const locationSearch = window.location.search.split('&');
  const id = locationSearch[1]?.split('=')[1];
  const title = locationSearch[2]?.split('=')[1]?.replace('%20', ' ');

  return { id, title };
};
const updatePackageDetailsInLocalStorage = () => {
  // FOR PENDING PACKAGES THAT THE USER RESUMED ON A LATER DATE,
  // THE PACKAGE ID AND PACKAGE NEEDS TO BE CONSTANTLY UPDATED IN THE STORAGE
  const { id, title } = getUrlParam();
  id &&
    localStorage.setItem('package-id', CryptoJS.AES.encrypt(JSON.stringify(id), wqkgx).toString());
  title &&
    localStorage.setItem('package', CryptoJS.AES.encrypt(JSON.stringify(title), wqkgx).toString());
};

// EVERY FORM WILL ALWAYS PASS THROUGH FORM 1, SO WE WANT TO UPDATE THE createdAt, packageid, and title only on
// click of save and continue on page one. This is because when the business registration page loads, each steps has their forms
// initialized as an empty object, to prevent any js issue that could occur.

export const setInLocalStorage = ({ prop, value }: TSetLocalStorage) => {
  const { id, title } = getUrlParam();
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const obj = decryptJson(localStorage.getItem(loginEmail));
  const stringifiedVal = JSON.stringify(value);

  const newObj =
    prop === 'form1' && Object.keys(value)?.length > 0
      ? {
          ...obj,
          [prop]: stringifiedVal,
          createdAt: obj?.createdAt ?? Date.now(),
          packageId: obj?.packageId ?? id,
          title: obj?.title ?? title,
        }
      : {
          ...obj,
          [prop]: stringifiedVal,
        };
  const encryptedString = encryptEntrepreneurData(newObj);

  updatePackageDetailsInLocalStorage();
  localStorage.setItem(loginEmail, encryptedString);
};

export const getFromLocalStorage = (prop: string) => {
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const obj = decryptJson(localStorage.getItem(loginEmail));
  return obj ? obj[prop] : '';
};

export const setInLocalStorageLtd = ({ prop, value }: TSetLocalStorage) => {
  const { id, title } = getUrlParam();
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const loginEmailLtd = loginEmail + 'ltd';
  const obj = decryptJson(localStorage.getItem(loginEmailLtd));

  const stringifiedVal = JSON.stringify(value);

  const newObj =
    prop === 'form1-ltd' && Object.keys(value)?.length > 0
      ? {
          ...obj,
          [prop]: stringifiedVal,
          createdAt: obj?.createdAt ?? Date.now(),
          packageId: obj?.packageId ?? id,
          title: obj?.title ?? title,
        }
      : {
          ...obj,
          [prop]: stringifiedVal,
        };
  const encryptedString = encryptEntrepreneurData(newObj);

  updatePackageDetailsInLocalStorage();
  localStorage.setItem(loginEmailLtd, encryptedString);
};

export const setInLocalStorageTrustee = ({ prop, value }: TSetLocalStorage) => {
  const { id, title } = getUrlParam();
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const loginEmailTrustee = loginEmail + 'trustee';
  const obj = decryptJson(localStorage.getItem(loginEmailTrustee));

  delete value['structureOfBusiness'];
  const stringifiedVal = JSON.stringify(value);
  const newObj =
    prop === 'form1-ltd' && Object.keys(value)?.length > 0
      ? {
          ...obj,
          [prop]: stringifiedVal,
          createdAt: obj?.createdAt ?? Date.now(),
          packageId: obj?.packageId ?? id,
          title: obj?.title ?? title,
        }
      : {
          ...obj,
          [prop]: stringifiedVal,
        };

  const encryptedString = encryptEntrepreneurData(newObj);

  updatePackageDetailsInLocalStorage();
  localStorage.setItem(loginEmailTrustee, encryptedString);
};

export const getFromLocalStorageLtd = (prop: string) => {
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const loginEmailLtd = loginEmail + 'ltd';
  const obj = decryptJson(localStorage.getItem(loginEmailLtd));
  if (obj && obj[prop]) {
    if (typeof obj[prop] === 'string') {
      return JSON.parse(obj[prop]);
    } else {
      return obj[prop];
    }
  } else {
    return '';
  }
};

export const getFromLocalStorageTrustee = (prop: string) => {
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const loginEmailLtd = loginEmail + 'trustee';
  const obj = decryptJson(localStorage.getItem(loginEmailLtd));
  if (obj && obj[prop]) {
    if (typeof obj[prop] === 'string') {
      return JSON.parse(obj[prop]);
    } else {
      return obj[prop];
    }
  } else {
    return '';
  }
};

export const hasARegistrationInLocalStorage = () => {
  const loginEmail = localStorage.getItem('login-email') ?? '';
  const loginEmailLtd = loginEmail + 'ltd';
  const loginEmailTrustee = loginEmail + 'trustee';

  const ltd_obj = decryptJson(localStorage.getItem(loginEmailLtd));
  const bus_obj = decryptJson(localStorage.getItem(loginEmail));
  const trustee_obj = decryptJson(localStorage.getItem(loginEmailTrustee));

  const ltdObj = ltd_obj?.['form1-ltd'];
  const busNameObj = bus_obj?.['form1'];
  const trusteeObj = trustee_obj?.['form1-ltd'];
  const ltdReg: TInfoltd = ltdObj && JSON.parse(ltdObj);
  const trusteeReg: TInfoltd = trusteeObj && JSON.parse(trusteeObj);
  const busNameReg: TInfoltd = busNameObj && JSON.parse(busNameObj);
  const NonEmptyReg: THasRegInStorage[] = [];
  if (ltdReg && Object.keys(ltdReg).length) {
    NonEmptyReg.push({
      'ltd-1million': {
        ...ltdReg,
        createdAt: ltd_obj?.createdAt?.toString(),
        packageId: ltd_obj?.packageId,
        title: ltd_obj?.title,
        type: 'TRegInStorage',
      },
    });
  }

  if (trusteeReg && Object.keys(trusteeReg).length) {
    NonEmptyReg.push({
      'incorporated-trustee': {
        ...trusteeReg,
        createdAt: trustee_obj?.createdAt?.toString(),
        packageId: trustee_obj?.packageId,
        title: trustee_obj?.title,
        type: 'TRegInStorage',
      },
    });
  }

  if (busNameReg && Object.keys(busNameReg).length) {
    NonEmptyReg.push({
      'business-Name': {
        ...busNameReg,
        createdAt: bus_obj?.createdAt?.toString(),
        packageId: bus_obj?.packageId,
        title: bus_obj?.title,
        type: 'TRegInStorage',
      },
    });
  }

  return NonEmptyReg;
};
